import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useNavigate, useParams } from "react-router-dom";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarDensitySelector,
  useGridApiContext,
  gridExpandedSortedRowIdsSelector,
} from "@mui/x-data-grid";

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@emotion/react';

// ----------------------------------------------------------------------


const flattenObject = (obj) => {
  return `${obj.name} ${obj.email} ${obj.phone}`;
};
const flattenArray = (arr) => {
  return arr.map((item) => `Title - ${item.title.replaceAll(",", "")} Quantity - ${item.quantity}  Code - ${item?.code}`).join('; ');
};
const removeComma = (string) => {
  return string.replaceAll(',', '');
};
function CustomToolbar({ rows, columns, ...gridProps }) {
  const { setQuickFilter, ...otherProps } = gridProps;
  // debugger;
  const apiRef = useGridApiContext();
  // console.log(gridProps)
  const exportAllRows = async () => {
    const visibleRows = gridExpandedSortedRowIdsSelector(apiRef);

    const filteredRows = rows.filter((row) => visibleRows.includes(row.id));

    const columnIds = columns.filter((column) => column.field !== 'actions').map((column) => column.field);
    const csvHeader = columnIds.join(', ');
    const csvContent = filteredRows
      .map((row) => {
        const rowValues = columnIds.map((columnId) => {
          if (columnId === 'userDetails') {
            return flattenObject(row.userDetails)
          }
          if (columnId === 'sno') {
            return row.sno
          }
          return row[columnId]?.toString()?.replaceAll(",", " ");
        });
        return rowValues.join(', ');
      })
      .join('\n');
    const fullCsvContent = `${csvHeader}\n${csvContent}`;

    // console.log('Exporting all rows:', fullCsvContent);
    const blob = new Blob([fullCsvContent], { type: `text/csv;charset=utf-8` });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'StoreUserSearchQuery.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />

      <GridToolbarDensitySelector />
      <Tooltip title="Export All">
        <IconButton onClick={exportAllRows}>
          <SaveAltIcon style={{ color: 'red' }} />
        </IconButton>
      </Tooltip>
      <GridToolbarQuickFilter debounceMs={999999} />
    </GridToolbarContainer>
  );
};

export default function SearchQueryTable() {
  const theme = useTheme();
  const { type } = useParams();

  const [rows, setRows] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 7,
  });
  const [search, setSearch] = useState("");
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };
  const [loading, setLoading] = useState(true)
  const fetchQueries = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');

    const res = await fetch(
      `${process.env.REACT_APP_LIVE_URL}/store/getSearchQuery` +
      `?type=${type}` +
      `&page=${paginationModel.page}` +
      `&pageSize=${paginationModel.pageSize}` +
      `&searchText=${encodeURIComponent(search)}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }
    );

    const json = await res.json();

    const data = json.data || [];

    const withId = data.map((r, i) => ({
      ...r,
      id: r._id || r.id || i,
      sno: paginationModel.page * paginationModel.pageSize + i + 1
    }));

    setRows(withId);
    setRowCount(json.pagination?.totalCount || json.count || data.length);
    setLoading(false);
  };
  React.useEffect(() => {
    fetchQueries();
  }, [type, paginationModel.page, paginationModel.pageSize, search]);
  React.useEffect(() => {
    const handler = (e) => {
      if (e.key !== "Enter") return;

      const el = document.activeElement;
      if (!el || el.tagName !== "INPUT") return;

      const value = el.value || "";

      // toolbar search
      if (el.closest(".MuiDataGrid-toolbarContainer")) {
        setSearch(value);
        setFilterModel(prev => ({
          ...prev,
          quickFilterValues: [value],
        }));
        setPaginationModel(p => ({ ...p, page: 0 }));
      }

      // filter panel search
      if (el.closest('[class*="MuiDataGrid-filterForm"]')) {
        setSearch(value);
        setPaginationModel(p => ({ ...p, page: 0 }));
      }
    };

    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  const columns = [

    {
      field: "sno",
      headerName: "Order Id",
      type: "object",
      width: 100,
      align: "left",
      headerAlign: "left",

    },
    {
      field: "userDetails",
      headerName: "User Details",
      type: "object",
      width: 350,
      align: "left",
      headerAlign: "left",
      editable: true,
      renderCell: (params) => (
        <div>
          <strong>Name :</strong> {params.value?.name}<br />
          <strong>Email :</strong> {params.value?.email}<br />
          <strong>Mobile Number :</strong> {params.value?.phone}
        </div>
      ),
      getApplyQuickFilterFn: (value) => {
        return (params) => {
          return (params?.value?.name?.includes(value) || params?.value?.email?.includes(value) || params?.value?.phone?.includes(value))

        }
        // return ( params.value.name.includes(value) )
      }
    },
    {
      field: "searchText",
      headerName: "Search Text",
      type: "string",
      width: 300,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "type",
      headerName: "Type",
      type: "string",
      width: 300,
      align: "left",
      headerAlign: "left",
    },
    // {
    //   field: "searchQuery",
    //   headerName: "DataBase Query",
    //   type: "string",
    //   width: 400,
    //   align: "left",
    //   headerAlign: "left",
    //   // editable: true,
    //   renderCell : (params) => (
    //     params?.value?.length > 0 ? <Stack spacing={2} direction='column' >
    //       { params?.value?.map((item) => {
    //       //  <span>{item?.title}</span>
    //       for (const [key, value] of Object.entries(item)) {
    //         // console.log(key , value)
    //         return (<span>{key} - {value}</span>)

    //        }
    //    })}
    //     </Stack> : <strong>NA</strong>

    //   )
    // },   
  ]



  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        "& .actions": {
          color: "text.secondary"
        },
        "& .textPrimary": {
          color: "text.primary"
        }
      }}
    >
      <h2 style={{ marginBottom: '15px' }}>{type == 'store' ? `Store User Search Query` : `Website User Search Query`}</h2>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}

        paginationMode="server"
        filterMode="server"

        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}

        filterModel={filterModel}
        onFilterModelChange={setFilterModel}

        getRowHeight={() => 'auto'}
        getEstimatedRowHeight={() => 200}
        autoHeight

        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        processRowUpdate={processRowUpdate}

        pageSizeOptions={[7, 50, 100]}

        slots={{
          toolbar: (gridProps) =>
            <CustomToolbar {...gridProps} rows={rows} columns={columns}></CustomToolbar>
        }}
      />
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
}
